import _get from 'lodash/get';
import { $window } from '@umu/umu-dom';
import { lang, _lang } from '@umu/ukit-lang';
import { fetch } from '@umu/umu-fetch';
import API from '@umu/umu-api';

enum EFontSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

type TFontSizeSwitch = {
    key: EFontSize;
    value: string;
};

const defaultText = lang('（默认）');

const defaultFontSizeNumber = 100;

const fontSizeSwitchList: TFontSizeSwitch[] = [
    {
        key: EFontSize.SMALL,
        value: `${lang('小字号')}${defaultText}`,
    },
    {
        key: EFontSize.MEDIUM,
        value: lang('中字号'),
    },
    {
        key: EFontSize.LARGE,
        value: lang('大字号'),
    },
];


const getFontSizeSwitchList = () => {
    return fontSizeSwitchList;
};

const getCurrentFontSize = () => {
    const currentFontSize = _get($window, 'pageData.config.node_html_font_size', EFontSize.SMALL);
    return currentFontSize;
};

const getCurrentFontSizeValue = () => {
    const currentFontSize = getCurrentFontSize();
    return fontSizeSwitchList.find((item) => item.key === currentFontSize)?.value || fontSizeSwitchList[0].value;
};

const transformPx2Rem = (value: number | string): string => {
    let pxValue: number;
    if (typeof value === 'number') {
        pxValue = value;
    } else if (typeof value === 'string') {
        if (value.endsWith('px')) {
            pxValue = Number(value.slice(0, -2));
        } else {
            return value;
        }
    } else {
        throw new Error('Invalid type for value. Expected number or string.');
    }

    const remValue = pxValue / 100;
    return `${remValue}rem`;
};

function isLogin() {
    const umuId = (window as any)?.pageData?.data?.user_info?.umu_id || 0;
    return parseInt(umuId, 10) > 0;
}
/**
 * 设置字体大小
 * @param {string}    fontSize     small 等
 */
function updateFontSize(fontSize: { key: string; value: string }) {
    if (isLogin()) {
        return fetch.post(API.Path.UPDATE_USER_SETUP.url, {
            option_type: 16,
            option_value: fontSize.key,
        });
    } else {
        return Promise.resolve();
    }
}

// 获取根节点font-size
const getRootFontSize = () => {
    const currentFontSizeValue = _get($window, 'pageData.config.node_html_font_size_value', defaultFontSizeNumber);
    return parseFloat(String(currentFontSizeValue));
}

function getRootScale() {
    return getRootFontSize() / defaultFontSizeNumber;
}

function isCanShowFontSizeSwitch() {
    return _lang('CN') || _lang('JP') || _lang('TW');
}

export {
    getRootScale,
    getRootFontSize,
    isLogin,
    getFontSizeSwitchList,
    getCurrentFontSize,
    getCurrentFontSizeValue,
    transformPx2Rem,
    updateFontSize,
    isCanShowFontSizeSwitch,
};
